import React, { useState } from 'react'
import SubscribePopup from '../subscribe/SubscribePopup.js'
import { nonRestrictedApiAxiosInstance } from '../../config/ConfigInfo';

function SubscribeForm() {

    const [subscribeErrorMsg, setSubscribeErrorMsg] = useState('');
    const [modalShow, setModalShow] = useState(false);
    const [subscribeInputData, setSubscribeInputData] = useState('');
    const [subscribeStatus, setSubscribeStatus] = useState(false);
    const [subscribeMessage, setSubscribeMessage] = useState('')
    const [btnDisabled, setBtnDisabled] = useState(false)

    const changeHandler = (e) => {
        setSubscribeInputData(e.target.value);
        setSubscribeErrorMsg('')
    }

    const subscribeForm = (e) => {
        e.preventDefault();
        let regex = /^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/;
        if (subscribeInputData === "") {
            setSubscribeErrorMsg('Please enter the email address!');
        } else if (!regex.test(subscribeInputData)) {
            setSubscribeErrorMsg('Please enter valid email address!');
        } else {
            (async () => {

                setModalShow(true);
                setBtnDisabled(true)
                try {
                    const emailIfo = {
                        email: subscribeInputData
                    }
                    const subscribeResponse = await nonRestrictedApiAxiosInstance.post("api/Job/Subscribe", emailIfo);
                    if (subscribeResponse.status === 200 && subscribeResponse.data.status === 200) {
                        setSubscribeInputData('')
                        setSubscribeErrorMsg('');
                        setSubscribeMessage(subscribeResponse.data.message);
                        setSubscribeStatus(subscribeResponse.data.data.isSubscribed);
                    }
                    setBtnDisabled(false)
                }
                catch (error) {
                    setSubscribeErrorMsg(error.message);
                    setBtnDisabled(false)
                }
            })();
        }
    }

    return (
        <>
            <div className="container py-5 outer-subscribe-section">
                <div className="never-want">
                    <div className="row">
                        <div className="col-md-6 col-12 mb-3">
                            <h4 className="mb-0">Don’t miss out on any job news</h4>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="never-want-inner">
                                <form onSubmit={subscribeForm}>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter email"
                                            name='subscribe'
                                            value={subscribeInputData}
                                            onChange={changeHandler}
                                            className='w-75  form-control'
                                        />
                                        {
                                            subscribeErrorMsg !== '' ?
                                                <p className="text-danger" >
                                                    {subscribeErrorMsg}
                                                </p>
                                                :
                                                ''
                                        }
                                    </div>
                                    <button type="submit" className="btn btn-dark px-4 mt-3" disabled={btnDisabled} >Subscribe</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Conditionally render the popup */}
            {modalShow && (
                <SubscribePopup
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    subscribemessagedata={subscribeMessage}
                    subscribestatusdata={subscribeStatus}
                    setSubscribeMessage={setSubscribeMessage}
                />
            )}
        </>
    )
}

export default SubscribeForm
